import React, { useEffect, useState } from 'react';
import { Col, Container, Form, Row } from 'react-bootstrap';
import StatisticsCards from '../component/StatisticsCards';
import {
  cfppData,
  cfsp,
  comoditydropdowndata,
  dropdowndata,
  statsData
} from './statsData';
import BarChartComponent from '../component/charts/barChart';
import UsersLocation from 'components/dashboards/lms/users-location/UsersLocation';
import MarketingExpenses from 'components/dashboards/lms/marketing-expenses/MarketingExpenses';
import axios from 'axios';
import {
  regionFarmerDetails,
  TotalProcuredAmount,
  volumeInfo
} from './chartsData';
import WidgetSectionTitle from 'widgets/WidgetSectionTitle';
import MonitoringStats from 'components/dashboards/monitoring/MonitoringStats';
import { sessionObjects } from '../session/sessionData';

function BeamDashboard() {
  // State for selected dropdown value
  const [selectedValue, setSelectedValue] = useState('All');
  const [selectedComodity, setSelectedComodity] = useState(
    comoditydropdowndata[0]?.value || ''
  );
  const [apiData, setApiData] = useState(null); // Store the API response data
  const [loading, setLoading] = useState(true); // Loading state for API call
  const [error, setError] = useState(null); // Error state

  // Filter statsData based on selected dropdown value
  const cfppStatsData = selectedValue
    ? cfppData.filter(item => item.title === selectedValue)
    : cfppData; // Show all data if no selectedValue or no match
  // Filter statsData based on selected dropdown value
  const filteredStatsData = statsData.filter(item => item.title === 'Rabi 24');

  // Filter statsData based on selected dropdown value
  const cfspStatsData = cfsp.filter(item => item.title === selectedComodity);

  // Handle change of dropdown selection
  const handleDropdownChange = value => {
    setSelectedValue(value);
  };

  let cfpp_details = {
    State: 'Maharashtra',
    Districts: '36',
    'Reported Districts': '23'
  };
  let cfsp_details = {
    State: 'Maharashtra',
    Districts: '36',
    'Reported Districts': '27'
  };

  return (
    <Container className="py-4">
      <Row className="mb-3">
        <WidgetSectionTitle
          title="CFPP"
          transform="shrink-4"
          className="mb-4 mt-4 align-items-center"
          light={true}
        />
        <Col md="12" className="mb-3">
          <MonitoringStats data={cfpp_details} />
        </Col>
        <Row className="d-flex justify-content-end p-0">
          <Col md="auto">
            <Form.Label>Mkt. Season</Form.Label>
            <Form.Select
              className="ps-2 pe-5 py-2"
              value={selectedValue}
              name="leftSide"
              onChange={e => handleDropdownChange(e.target.value)}
            >
              <option value="kmf">KMF</option> {/* Hardcoded option */}
            </Form.Select>
          </Col>
          <Col md="auto">
            <Form.Label>Mkt. Year</Form.Label>
            <Form.Select
              className="ps-2 pe-5 py-2"
              value={selectedValue}
              name="leftSide"
              onChange={e => handleDropdownChange(e.target.value)}
            >
              <option value="2024-2025">2024-2025</option>{' '}
              {/* Hardcoded option */}
            </Form.Select>
          </Col>
          <Col md="auto">
            <Form.Label>Commodity</Form.Label>
            <Form.Select
              className="ps-2 pe-5 py-2"
              value={selectedValue}
              name="leftSide"
              onChange={e => handleDropdownChange(e.target.value)}
            >
              <option value="paddy">Paddy</option> {/* Hardcoded option */}
            </Form.Select>
          </Col>
          <Col md="auto">
            <Form.Label>Crop Type</Form.Label>
            <Form.Select
              className="ps-2 pe-5 py-2"
              value={selectedValue}
              name="leftSide"
              onChange={e => handleDropdownChange(e.target.value)}
            >
              <option value="kharif">Kharif</option> {/* Hardcoded option */}
            </Form.Select>
          </Col>
          <Col md="auto">
            <Form.Label>Agency</Form.Label>
            <Form.Select
              className="ps-2 pe-5 py-2"
              value={selectedValue}
              name="leftSide"
              onChange={e => handleDropdownChange(e.target.value)}
            >
              <option value="All">Consolidated</option> {/* Hardcoded option */}
              <option value="Markfed">Markfed</option> {/* Hardcoded option */}
              <option value="TDC">TDC</option> {/* Hardcoded option */}
            </Form.Select>
          </Col>
        </Row>
      </Row>

      {/* Display Statistics Cards based on filtered data */}
      <Row className="mb-3">
        <Col lg={6} xxl={6}>
          <UsersLocation />
        </Col>
        <Col lg={6} xxl={6}>
          <StatisticsCards statsData={cfppStatsData} />
        </Col>
      </Row>

      <Row className="mb-3">
        <WidgetSectionTitle
          title="CFSP"
          transform="shrink-4"
          className="mb-4 mt-4 align-items-center"
          light={true}
        />
        <Col>
          <MonitoringStats data={cfsp_details} />
        </Col>
      </Row>

      <Row className="mb-3">
        <Col lg={6} xxl={6}>
          <UsersLocation />
        </Col>
        <Col lg={6} xxl={6}>
          <StatisticsCards statsData={cfspStatsData} />
        </Col>
      </Row>

      <Row className="mb-3">
        <WidgetSectionTitle
          title="Additional Data"
          transform="shrink-4"
          className="mb-4 mt-4 align-items-center"
          light={true}
        />
        <Col md="auto" className="ms-auto">
          <Form.Select
            className="ps-2 pe-5 py-2"
            value={selectedComodity}
            name="leftSide"
            // onChange={e => setSelectedComodity(e.target.value)}
          >
            <option value="kharif">Kharif 24</option>
            {/* {comoditydropdowndata.map(item => (
              <option key={item.id} value={item.value}>
                {item.value}
              </option>
            ))} */}
          </Form.Select>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col>
          <StatisticsCards statsData={filteredStatsData} lg={3} />
        </Col>
      </Row>
      <Row className="g-3">
        <WidgetSectionTitle
          title="Data Insights"
          transform="shrink-4"
          className="mb-4 mt-4 align-items-center"
          light={true}
        />
        <Col lg={12} xxl={12}>
          <BarChartComponent data={regionFarmerDetails} />
        </Col>
        <Col lg={6} xxl={6}>
          <BarChartComponent data={volumeInfo} />
        </Col>
        {/* <Col lg={6} xxl={6}>
          <BarChartComponent data={TopSocieties} />
        </Col> */}
        <Col lg={6} xxl={6}>
          <BarChartComponent data={TotalProcuredAmount} type={'line'} />
        </Col>
        {/* <Col lg={6} xxl={6}>
          <BarChartComponent data={TopSocieties} />
        </Col> */}
      </Row>
    </Container>
    // <>
    //   {apiData?.map((item, index) => {
    //     console.log(item.type, 'itemss');
    //     if (item.type == 'DataListBlocks') {
    //       return (
    //         <Row key={index} className="g-3 mb-3">
    //           <BlockList index={index} dashboardKey={'dashboard_beam_fcs'} />
    //         </Row>
    //       );
    //     } else if (item.type == 'StaticChart') {
    //       return (
    //         <DashboardChartComponent
    //           key={index}
    //           index={index}
    //           dashboardKey={'dashboard_beam_fcs'}
    //         />
    //       );
    //     } else if (item.type == 'DataList') {
    //       return (
    //         <ReportComponent
    //           key={index}
    //           index={index}
    //           dashboardKey={'dashboard_beam_fcs'}
    //         />
    //       );
    //     }
    //   })}
    // </>
  );
}

export default BeamDashboard;
